import React from 'react';
import { Box, Typography, Paper, Grid, Chip } from '@mui/material';
import { Role } from '../../../types/role.types';
import { UserWizardData } from '../../../types/user.types';
import type { Location } from '../../../api';

interface WizardStep3Props {
  formData: UserWizardData;
  roles: Role[];
  locations?: Location[];
}

const WizardStep3: React.FC<WizardStep3Props> = ({ formData, roles, locations = [] }) => {
  const selectedRoles = roles.filter((role) => formData.roleIds.includes(role.id));
  const selectedLocation = locations.find((location) => location.id === formData.primaryLocationId);
  const locationLabel = selectedLocation?.name || '—';

  return (
    <Box sx={{ py: 3 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
            Información Básica
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                Correo
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 600, mt: 0.5 }}>
                {formData.email || '—'}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                Teléfono
              </Typography>
              <Typography variant="body1" sx={{ mt: 0.5 }}>
                {formData.phone || '—'}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                Nombre
              </Typography>
              <Typography variant="body1" sx={{ mt: 0.5 }}>
                {formData.firstName || '—'}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                Apellido
              </Typography>
              <Typography variant="body1" sx={{ mt: 0.5 }}>
                {formData.lastName || '—'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                Estado
              </Typography>
              <Typography variant="body1" sx={{ mt: 0.5 }}>
                {formData.isActive ? 'Activo' : 'Bloqueado'}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                Sucursal Asignada
              </Typography>
              <Typography variant="body1" sx={{ mt: 0.5 }}>
                {locationLabel}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                Ventas multi-sucursal (venta y órdenes en todas las sucursales)
              </Typography>
              <Typography variant="body1" sx={{ mt: 0.5 }}>
                {formData.canSellFromOtherLocations ? 'Sí' : 'No'}
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        <Paper
          elevation={0}
          sx={{
            p: 3,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
            Roles asignados
          </Typography>
          {selectedRoles.length === 0 ? (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Sin roles asignados
            </Typography>
          ) : (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {selectedRoles.map((role) => (
                <Chip
                  key={role.id}
                  label={role.name}
                  size="small"
                  sx={{
                    backgroundColor: 'rgba(34, 211, 238, 0.12)',
                    color: '#0891b2',
                    fontWeight: 600,
                  }}
                />
              ))}
            </Box>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default WizardStep3;
